import { useEffect, useState } from 'react';
import { useDebounce } from '@hooks/useDebounce';
import { IFilterProductPriceProposal } from '@type/productPriceProposal';
import { IFilter } from '@type/param';
import { ESortOrder } from '@type/product';
import { IProductCustomPrice } from '../ProductPriceTable';
import productPriceProposalApi from '@apis/productPriceProposal';

export function useProductPriceProposalTable(userId?: string) {
  const [productPriceProposal, setProductPriceProposal] = useState<IProductCustomPrice[]>([]);
  const [totalData, setTotalData] = useState(0);

  const [filters, setFilters] = useState<IFilter<IFilterProductPriceProposal>>({
    limit: 10,
    page: 1,
    sort: 'updatedAt',
    order: ESortOrder.Asc,
    filters: { userId: userId || '' },
  });

  const [search, setSearch] = useState('');
  const searchDebounce = useDebounce(search, 500);

  // Fetch product list
  useEffect(() => {
    if (!userId) return;
    productPriceProposalApi
      .getListPagination(userId, {
        ...filters,
        keyword: searchDebounce,
        filters: { ...filters.filters },
      })
      .then(({ data }) => {
        setProductPriceProposal(data?.data || []);
        setTotalData(data?.totalData || 0);
      })
      .catch(() => {
        setProductPriceProposal([]);
        setTotalData(0);
      });
  }, [filters, searchDebounce, userId]);

  const refreshList = () => {
    setFilters((prev) => ({ ...prev }));
  };

  return {
    productPriceProposal,
    totalData,
    filters,
    setFilters,
    search,
    setSearch,
    refreshList,
  };
}
